import React from 'react';
import GameAddEdit from '../../../components/admin/GameAddEdit/GameAddEdit';
import styles from './AdminParentGameCreate.module.scss';
import ParentGameAddEdit from '../../../components/admin/ParentGameAddEdit/ParentGameAddEdit';
const AdminParentGameCreate = () => {
  return <ParentGameAddEdit />;
};

export default AdminParentGameCreate;
